import { NavigationService } from './navigation.service';
import { fadeInOut } from './animations';
import { Component, ElementRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import * as Cookies from 'js-cookie';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [fadeInOut]
})
export class AppComponent {
  title = 'sn-wizard';

  constructor(
    public nav: NavigationService,
    private elementRef: ElementRef
  ) {
    //let attribution = this.elementRef.nativeElement.getAttribute('rnattrib');
    let attribution = this.verifyAttribution();
    //attribution = JSON.parse(attribution);
    // tslint:disable-next-line: forin
    for (const key in attribution) {
      this.nav.setAttribution(key, attribution[key]);
    }
  }

  verifyAttribution() {
    let variation = {
      lead_type: "", lead_source: "", lead_utm_campaign: "", lead_utm_term: "", lead_utm_content: "", lead_utm_name: "", lead_page: ""
    };
    // Checking lead_type and lead_source, these form values should never be blank.
    if (!!Cookies.get('lead_type')) {
      var lead_type_cookie_value = Cookies.get("lead_type");
      variation.lead_type = lead_type_cookie_value;
    }
    else {
      let attribution = this.elementRef.nativeElement.getAttribute('rnattrib');
      attribution = JSON.parse(attribution);
      return attribution;
    }
    if (!!Cookies.get('lead_source')) {
      var lead_source_cookie_value = Cookies.get("lead_source");
      variation.lead_source = lead_source_cookie_value;
    }
    // Checking UTMs. If the cookie does not exist, then we need to clear the form values.
    if (!!Cookies.get('lead_utm_campaign')) {
      var lead_utm_campaign_cookie_value = Cookies.get("lead_utm_campaign");
      variation.lead_utm_campaign = lead_utm_campaign_cookie_value;
    }
    if (!!Cookies.get('lead_utm_term')) {
      var lead_utm_term_cookie_value = Cookies.get("lead_utm_term");
      variation.lead_utm_term = lead_utm_term_cookie_value;
    }
    if (!!Cookies.get('lead_utm_content')) {
      var lead_utm_content_cookie_value = Cookies.get("lead_utm_content");
      variation.lead_utm_content = lead_utm_content_cookie_value;
    }
    if (!!Cookies.get('lead_utm_name')) {
      var lead_utm_name_cookie_value = Cookies.get("lead_utm_name");
      variation.lead_utm_name = lead_utm_name_cookie_value;
    }
    // WE DO NOT SAVE lead_page IN A COOKIE BECAUSE WE ALWAYS WANT TO RECORD THE ACTUAL PAGE WE ARE ON. NO FIRST CLICK ATTRIBUTION FOR lead_page
    var lead_page_current_val = window.location.href.split('?')[0].replace(/(^\w+:|^)\/\//, '');
    variation.lead_page = lead_page_current_val;
    return variation;
  }

  prepareRoute(outlet: RouterOutlet) {
    return (
      outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation
    );
  }
}
